import "./App.css";
import AppRouter from "./appRouter";
import { Provider } from "react-redux";
import store from "./Redux/store";
// import useScanDetection from 'use-scan-detection';
import { useEffect, useState } from "react";
import axios from "axios";
import { Base_Uri } from "./Constant/BaseUri";
import { CUSTOMERINFO, IS_EDIT_OPEN, SELECTED_CUSTOMER, SELECTED_INVOICES, SOCKETS } from "./Context";


import {
  Font,
} from "@react-pdf/renderer";

// //import MyFontRegular from "/fonts/Poppins-Medium.ttf";
// import MyFontBold from "/fonts/Poppins-Bold.ttf";

Font.register({
        family: 'MyFont',
        fonts: [
            { src: "/fonts/Poppins-Bold.ttf", fontWeight: 'bold' },
            { src: "/fonts/Poppins-Medium.ttf", fontWeight: 'normal' },
        ]
    });

function App() {
  const [barcode, setBarcode] = useState("");
  const [allowedCountries, setAllowedCountries] = useState([]);

  // const fetchCountries = () => {
  //   axios.get(`${Base_Uri}countries`)
  //     .then(res => setAllowedCountries(res.data))
  //     .catch(err => console.error("Error fetching countries:", err));
  // };
  const [isAllowed, setIsAllowed] = useState(false);

  // useScanDetection({
  //   onComplete: (code) => {

  //     setBarcode(code)

  // useEffect(()=>{
  //   fetchCountries()
  // },[])

  const [userData, setUserData] = useState([]);
  const [selectedInvoice, setSelectedInvoice] = useState("");
  const [selectCustomerId,setSelectedCustomerId] = useState({})
  const [socketsData,setSocketsData] = useState(null)
  const [isEditOpen,setIsEditOpen] = useState(false)
  const [extraCustomerInfo,setExtraCustomerInfo] = useState({})

  // useEffect(() => {
  //   fetch("https://api64.ipify.org?format=json")
  //     .then((res) => res.json())
  //     .then((data) => {setIp(data.ip)
  //       console.log(data.ip)
  //     })
  //     .catch((err) => console.error(err));
  // }, []);

  // useEffect(() => {
  //   fetch("http://ip-api.com/json/")
  //     .then((res) => res.json())
  //     .then((data) => setUserData(data)); // Full country name (e.g., "United States")
  // }, []);

  // useEffect(()=>{
  //     let checkAccess = allowedCountries.filter(e=>e.code==userData.countryCode)
  //     setIsAllowed(checkAccess.length!=0)
  // },[allowedCountries,userData])

  return (
    <SOCKETS.Provider value={{socketsData,setSocketsData}}>

    <SELECTED_INVOICES.Provider  value={{selectedInvoice, setSelectedInvoice}}>
    <SELECTED_CUSTOMER.Provider  value={{selectCustomerId,setSelectedCustomerId}}>
      <IS_EDIT_OPEN.Provider value={{isEditOpen,setIsEditOpen}}>
    <CUSTOMERINFO.Provider value={{extraCustomerInfo,setExtraCustomerInfo}}>

 <Provider store={store}>
      {
        <div className="App">
          <AppRouter />
        </div>
      }
      {/* { <div className="restricted-container">
      <div className="warning-icon">⚠️</div>
      <h1>Access Denied</h1>
      <p>Sorry, your country is restricted from accessing this content.</p>
      
    </div>} */}
      <div
        style={{
          fontFamily: "Poppins",
          fontSize: 12,
          color: "#6e6e6e",
          fontWeight: "600",
          position: "fixed",
          bottom: 5,
          right: 5,
        }}
      >
        V1.0 (RETAIL)
      </div>
    </Provider>
    </CUSTOMERINFO.Provider>
      </IS_EDIT_OPEN.Provider>
    </SELECTED_CUSTOMER.Provider>
    </SELECTED_INVOICES.Provider>
    </SOCKETS.Provider>
   
  );
}

export default App;
